import React from 'react';
import ReactImageFallback from "react-image-fallback";
import {Modal, ModalBody} from "reactstrap";
import UploadFile from "../includes/UploadFile";
import PropTypes from "prop-types";
import {withRouter} from "react-router";
import {connect} from "react-redux";
import * as userActions from "../../actions/user";
import * as uploadActions from "../../actions/upload";
import * as playlistActions from "../../actions/playlist";
import * as pagesActions from "../../actions/pages";
import AuthService from '../../lib/AuthService';
import {Collapse} from 'reactstrap'

class HeaderBar extends React.Component {
    constructor(props) {
        super(props);
        this.state= {
            loggedOut : false,
            showProfileModal : false,
            user_name: '',
            user_pass : '',
            user_email: '',
            user_no :'',
            permissionlist:'',
            usernameErrormsg : '',
            passwordErrormsg:'',
            emailErrormsg : '',
            phnoErrormsg : '',
            image_path: null,
            changePwd:false,
            showMenuOptions : false,
            menuType : 'pc'
        };
        this.Auth = new AuthService();

        this.logout = this.logout.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.resetState  = this.resetState.bind(this);
        this.changePwd = this.changePwd.bind(this);
        this.hidePwd = this.hidePwd.bind(this);
        this.handleMenuOptions = this.handleMenuOptions.bind(this);
    }

    componentWillMount() {

        console.log(this.Auth.getProfile());
        if (!this.Auth.loggedIn()) {
            this.props.history.push('/login');
        }
        else{
            let data = { user_id : this.Auth.getProfile().user_id };
                this.props.logActivity(data);
        }
    }

    componentDidMount() {
        //alert(this.props.pageSettingsData.config.length)
        if(this.props.pageSettingsData.config.length >0)
        fetch("config.json")
            .then(response => response.json())
            .then(data => {
                console.log(data);
                this.props.saveConfig(data);
            });



        let data = { user_id : this.Auth.getProfile().user_id };
        this.props.getUserDetails(data);
        //mobile query
        const mq = window.matchMedia( "(max-width: 767px)" );
        if (mq.matches) {
            document.getElementsByClassName('content-area')[0].classList.remove('inner-skew');
            this.setState({menuType : 'mobile'});
            //mobile
        }
        else{
            this.setState({menuType : 'pc'})
        }
    }

    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {


        if(this.props.userData.editProfile !== prevProps.userData.editProfile ){
            let currentUser = this.props.userData.currentUser ? this.props.userData.currentUser : undefined;
            this.setState({'image_path' : this.props.pageSettingsData.config.BUCKET_PATH+'assets/slider/'+currentUser.uniqueId+'.jpg',
                'user_name' : currentUser.name,
                'user_email' : currentUser.display_name,
                'user_no' : currentUser.phone,
                'user_id' : currentUser.uniqueId,
            })
        }

    }
    handleMenuOptions() {
        this.setState({showMenuOptions : !this.state.showMenuOptions});
    }
    toggleMenu() {
        let menu_area = document.getElementsByClassName('side-content-area');
        if(this.state.menuType === 'mobile') {
            menu_area = document.getElementsByClassName('side-content-area');

            if( menu_area[0].classList.contains("active")) {
                menu_area[0].classList.remove("active");
            }
            else {
                menu_area[0].classList.add("active")
            }
        }
        else {
            menu_area = document.getElementsByClassName('content-area');
            if( menu_area[0].classList.contains("inner-skew")) {
                menu_area[0].classList.remove("inner-skew");
            }
            else {
                menu_area[0].classList.add("inner-skew")
            }
        }
    }
    changePwd(){
        this.setState({
            changePwd : true,
        })
    }
    hidePwd(){
        this.setState({
            changePwd : false,
        })
    }
    logout() {
        this.Auth.logout();
        window.location = '/login';
    }

    toggle(){

        let currentUser = this.props.userData.currentUser ? this.props.userData.currentUser : undefined;
        this.setState({
            showProfileModal: !this.state.showProfileModal,
        });
        this.props.editProfile();
        this.props.uploadErrors({'error' : '', fileType : ''})
        this.resetState();
    }
    resetState(){
        this.setState ({
            loggedOut : false,
            user_name: '',
            user_pass : '',
            user_email: '',
            user_no :'',
            permissionlist:'',
            usernameErrormsg : '',
            passwordErrormsg:'',
            emailErrormsg : '',
            phnoErrormsg : '',
            image_path: null,
        });
    }
    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });

        if(event.target.value !== '') {
            event.target.classList.remove('is-invalid');
        }
        if(this.state.user_type !== ''){
            this.setState({
                usertypeErrormsg: ''
            });
        }
        if(this.state.user_name !== ''){
            this.setState({
                usernameErrormsg: ''
            });
        }
        if(this.state.user_email !== '' && event.target.name === 'user_email'){

            var userEmailData =  {
                user_email: event.target.value,
                user_id: this.props.userData.currentUser ? this.props.userData.currentUser.uniqueId : ''
            };
            console.log(userEmailData)
            this.props.checkExistingUser(userEmailData);

            this.setState({
                emailErrormsg: ''
            });

        }

        if(this.state.user_no !== ''){
            this.setState({
                phnoErrormsg: ''
            });
        }
    }
    getUploadedFile(fileName) {
        console.log(fileName);
        this.setState({
            image_path: fileName
        });
        console.log(this.state.image_path+"========= thi.state.iamgepath");

        let filePathToBePurged = this.props.pageSettingsData.config.IMGIX_PATH+'assets/slider/'+this.Auth.getProfile().user_id+'.jpg?fit=crop&h=150&w=150&auto=enhance&dpr=3%203x';
        //Request to purging
        this.props.getImagepurged({image_name : this.state.user_id, image_path : filePathToBePurged});

    }
    handleSubmit(e) {
        console.log(this.state);
        //e.preventDefault();
        let formInvalid = 0;

        //Name validation

        if( this.state.user_name === '') {
            formInvalid++;
            document.getElementsByName('user_name')[0].classList.add('is-invalid');
            this.setState({
                usernameErrormsg: 'Username is required'
            });
        }

        //Password validation
        if(this.state.changePwd === true){
            if (this.state.user_pass === "") {
                formInvalid++;
                document.getElementsByName('user_pass')[0].classList.add('is-invalid');
                this.setState({
                    usertypeErrormsg: ' Password is required'
                });
            }

        }

        //* Email validation

        let email=/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

        if (this.state.user_email === ""){
            formInvalid++;
            document.getElementsByName('user_email')[0].classList.add('is-invalid');
            this.setState({
                emailErrormsg: 'User Email is required'
            });
        }
        else
        {
            if(!email.test(this.state.user_email))
            {

                formInvalid++;
                document.getElementsByName('user_email')[0].classList.add('is-invalid');
                this.setState({
                    emailErrormsg: 'Email is not valid'
                });

            }
            else{
                if(this.props.userData.userExists=== 'invalid') {
                    formInvalid++;
                    this.setState({
                        emailErrormsg: 'Email already existing'
                    });
                }
                else{

                    this.setState({validation: true})
                }

            }
        }




        //*Phone no validation

        if(this.state.user_no === "")
        {
            formInvalid++;
            document.getElementsByName('user_no')[0].classList.add('is-invalid');
            this.setState({
                phnoErrormsg: 'Phone Number is required'
            });
        }
        else
        {
            if(isNaN(this.state.user_no))
            {
                formInvalid++;
                document.getElementsByName('user_no')[0].classList.add('is-invalid');
                this.setState({
                    phnoErrormsg: 'Phone Number is not valid'
                });
            }
            else
            {
                if (this.state.user_no.length!=10)
                {
                    formInvalid++;
                    document.getElementsByName('user_no')[0].classList.add('is-invalid');
                    this.setState({
                        phnoErrormsg: 'Phone Number is not valid'
                    });
                }
                else{
                    this.setState({
                        phnoErrormsg: ''
                    });
                }

            }
        }

        if( formInvalid === 0) {

            let userid = this.props.userData.currentUser ? this.props.userData.currentUser.uniqueId : '';
            var userProfile = {
                user_email: this.state.user_email,
                user_name: this.state.user_name,
                user_phone: this.state.user_no,
                password: this.state.user_pass,
                user_id: userid
            };

            console.log(userProfile);
            let profileUpdated = this.props.updateProfile(userProfile);
            console.log(profileUpdated);

            //this.props.forceUpdateHandler();
            this.toggle();


        }

    }
    render() {

        console.log(this.props.userData.editProfile)
        let profileImgSrc = this.props.pageSettingsData.config.BUCKET_PATH+'assets/slider/'+this.Auth.getProfile().user_id+'.jpg';
        return (

            <header className="header-block">
                <div className="header-block-wrapper">
                    <div className="brand-logo">
                        <img src={require('../../assets/images/Nuggets-logo.png')}  width={200} alt="Nuggets" />
                    </div>
                    <div className="center-block">
                        <div className="toggle-block">
                            <button className="icon-lib-list menu-toggle-button" onClick={()=>this.toggleMenu()}></button>
                        </div>
                        <div className="user-info-block">

                            <div className="user-block">
                                <span className="user-image icon-lib-af drop-ico"
                                aria-controls="collapse-menu-options"
                                    aria-expanded={this.state.showMenuOptions}  onClick={()=>this.handleMenuOptions()}>
                                    <ReactImageFallback
                                        src={profileImgSrc}
                                        fallbackImage='assets/images/avatar.png'
                                        initialImage='assets/images/avatar.png'
                                        alt={this.Auth.getProfile().user_name}
                                        className="my-image" />
                                </span>
                                <Collapse isOpen={this.state.showMenuOptions}>
                                <div id="collapse-menu-options" className="user-toggle">
                                    <ul>
                                        <li>
                                            <span href="javascript:void(0);" className="user-toggle-click">{this.Auth.getProfile().user_name}</span>
                                        </li>
                                        <li>
                                         <span href="javascript:void(0);" className="user-toggle-click drp-bdr" onClick={this.toggle}>Profile</span>
                                        </li>
                                        <li>
                                            <span href="javascript:;" className="user-toggle-click" onClick={this.logout}>Logout</span>
                                        </li>
                                    </ul>
                                </div>
                                </Collapse>
                            </div>
                        </div>
                    </div>

                </div>
                <Modal isOpen={this.state.showProfileModal} toggle={this.toggle} centered={true} className="vig-mod modal-lg vig-modal user-md create-new-pop" id="vignetModal-user" tabindex="-1" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <ModalBody>
                        <div className="modal-content-wrapper">
                            <div className="modal-header">
                                <form id="company">
                                    <button type="button" className="modal-btn-close" data-dismiss="modal" aria-label="Close" onClick={this.toggle} >✕</button>
                                    <h4 className="modal-title icon-lib title-icon">Profile</h4>
                                </form>
                            </div>
                            <div className="modal-adduser-content">
                                <div className="modal-adduser-content-left">
                                    <div className="modal-adduser-detail">
                                        <p>NAME</p>
                                        <div className="input-select">
                                            <input type="user-name" name="user_name" defaultValue={this.state.user_name} placeholder="Username" onChange={this.handleInputChange} valid={false} />
                                            <p className="error-message">{this.state.usernameErrormsg}</p>
                                        </div>
                                    </div>
                                    <div className="modal-adduser-detail">
                                        <p>EMAIL</p>
                                        <div className="input-select">
                                            <input type="email" name="user_email" defaultValue={this.state.user_email} placeholder="Enter your email address" onChange={this.handleInputChange} valid={false} />
                                            <p className="error-message">{this.state.emailErrormsg}</p>
                                        </div>
                                    </div>
                                    <div className="modal-adduser-detail">
                                        <p>PHONE</p>
                                        <div className="input-select">
                                            <input type="number" name="user_no" defaultValue={this.state.user_no} placeholder="Enter your phone number" onChange={this.handleInputChange} valid={false} />
                                            <p className="error-message">{this.state.phnoErrormsg}</p>
                                        </div>
                                    </div>
                                    <div className="modal-adduser-detail">
                                        <p><a href="javscript:;" onClick={this.changePwd}>Change Password</a></p>
                                    </div>
                                    {this.state.changePwd === true &&
                                        <div>
                                    <div className="modal-adduser-detail">
                                        <p>PASSWORD</p>
                                        <div className="input-select">
                                            <input type="password" name="user_pass" defaultValue={this.state.user_pass}
                                                   placeholder="Password" onChange={this.handleInputChange}
                                                   valid={false}/>
                                            <p className="error-message">{this.state.passwordErrormsg}</p>
                                        </div>
                                    </div>
                                    <div className="modal-adduser-detail">
                                        <p><a href="javscript:;" onClick={this.hidePwd}>Hide Password</a></p>
                                        </div>
                                        </div>
                                    }

                                </div>
                                <div className="modal-adduser-content-right">
                                    <div className="modal-adduser-detail">
                                        <div className="modal-adduser-img">
                                            <div className="image-up" id="image-upload-container">

                                                {this.state.image_path &&
                                                <img src={this.state.image_path} crossOrigin="anonymous" className="text-center" alt="user"/>
                                                }
                                                {this.state.image_path === null &&
                                                <img src="assets/images/placeholder.png" alt="default" />
                                                }

                                                <UploadFile getUploadedFile={ this.getUploadedFile.bind(this)} type="add" item_type='USER' fileType="image" unique_id = {this.props.userData.currentUser ? this.props.userData.currentUser.uniqueId : ''} />
                                                {this.props.uploadData.loader &&

                                                <div id="progress-bar-wrapper"></div>
                                                }

                                            </div>
                                        </div>
                                        {this.props.uploadData.errors === true &&
                                        <p className="error-message">{this.props.uploadData.errorMessage}</p>
                                        }
                                    </div>
                                </div>
                                <div className="modal-adduser-content-btn">
                                    <div className="modal-btn btn-cancel">
                                        <a href="javascript:void(0);" className="" onClick={this.toggle}>CANCEL</a>
                                    </div>
                                    <div  className="modal-btn btn-create">
                                        <a href="javascript:void(0);" className="" onClick = {(e) => this.handleSubmit(e)}>UPDATE</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </header>

        );
    }
}

HeaderBar.propTypes = {
    completed: PropTypes.number
}
function mapStateToProps(state) {
    return {
        uploadData : state.upload.uploadData,
        userData  :state.user.userListData,
        pageSettingsData  : state.pages.pageSettings
    };
}
export default  withRouter(connect(mapStateToProps, {
    uploadErrors: uploadActions.uploadErrors,
    checkExistingUser :userActions.checkExistingUser,
    getImagepurged : playlistActions.purgeImage,
    getUserDetails :userActions.getUser,
    editProfile:userActions.editProfile,
    updateProfile:userActions.updateProfile,
    logActivity:pagesActions.logActivity,
    saveConfig : pagesActions.saveConfig,
})(HeaderBar));



// WEBPACK FOOTER //
// ./src/components/common/HeaderBar.js